import { HFlow, Icon, Text, Tooltip } from 'bold-ui'
import { blue } from 'bold-ui/lib/styles/colors'
import { DateTime } from 'components/date'
import { booleanToSimNaoEnum, simNaoEnumRecord } from 'components/form'
import { parseISO } from 'date-fns'
import { calculateIdadeGestacional } from 'util/atendimento/gestante/calculateIdadeGestacional'
import { isUndefinedOrNull } from 'util/checks'
import { formatNumber } from 'util/number'

const NAO_INFORMADO = '—'

export function renderNumeroConsulta(valor: number) {
  return <Text>{valor}ª</Text>
}

export function renderDataMedicao(valor: LocalDate) {
  return <Text>{valor ? <DateTime value={valor} format='DD/MM/YYYY' /> : NAO_INFORMADO}</Text>
}

export function renderIdadeGestacional(dataInicioGestacao: Date, dataConsulta: LocalDate) {
  const {
    emSemanas: { semanas, dias },
    hasIdadeGestacional,
  } = calculateIdadeGestacional(dataInicioGestacao, parseISO(dataConsulta))
  return <Text>{hasIdadeGestacional ? `${semanas}s e ${dias}d` : NAO_INFORMADO}</Text>
}

export function renderEdema(valor: string) {
  return <Text>{valor ? `(${valor})` : NAO_INFORMADO}</Text>
}

export function renderMovimentacaoFetal(valor: boolean, isRegistradoAgora: boolean) {
  return (
    <HFlow alignItems='center' justifyContent='space-between'>
      <Text>{isUndefinedOrNull(valor) ? NAO_INFORMADO : simNaoEnumRecord[booleanToSimNaoEnum(valor)]}</Text>
      {isRegistradoAgora && (
        <Tooltip text='Registrado agora'>
          <Icon color={blue.c40} size={1} icon='clockOutline' />
        </Tooltip>
      )}
    </HFlow>
  )
}

export function renderMedicaoPreNatal(valor: string | number) {
  return valor ? formatNumber(valor, 2) : NAO_INFORMADO
}

export function renderPressaoArterial(valor: string | number) {
  return <Text>{valor ?? NAO_INFORMADO}</Text>
}

export function renderLabelIG(isIgEcografica: boolean, showRegistradoAgora: boolean) {
  return (
    <HFlow alignItems='center' justifyContent='space-between' hSpacing={0.3}>
      <Text>{isIgEcografica ? 'IG (eco. obst.)' : 'IG (DUM)'}</Text>
      {showRegistradoAgora && (
        <Tooltip text='Registrado agora'>
          <Icon color={blue.c40} size={1} icon='clockOutline' />
        </Tooltip>
      )}
    </HFlow>
  )
}
